<template>
  <div class="panel panel-default">
    <div class="panel-heading">Gerenciar Cobrança</div>
    <div class="panel-body">
      <form @submit.prevent="atualizaFee" name="update-fee">
        <div class="row mb-10 text-center">
          <div class="col-sm-1"></div>
          <div class="col-sm-5">
            <div class="input-group justify-content-md-center">
              <input type="radio" id="cobrancaFee" class="custom-control-input" :value=true v-model="tipoCobranca"/>
              <label class="custom-control-label" for="cobrancaFee" style="padding-left:8px">Fee</label>
            </div>
          </div>
          <div class="col-sm-5">
            <div class="justify-content-md-center">
              <input type="radio" id="cobrancaRecorrente" class="custom-control-input" :value=false v-model="tipoCobranca"/>
              <label class="custom-control-label" for="cobrancaRecorrente" style="padding-left:8px">Recorrente</label>
            </div>
          </div>
        </div>
        <template v-if="tipoCobranca">
        <div class="col-sm-12 mt-10 mb-10 padding-off mt-lg-5">
          <div class="row padding-off">
            <div class="col-md-4">
              <div class="input-group align-text-bottom">Vôos:</div>
            </div>
            <div class="col-md-8">
              <div class="input-group">
                <label class="sr-only" for="fee-flight">Voos</label>
                <input type="text" id="fee-flight" name="fee-flight" class="form-control" placeholder="0,00" v-model="fee['fee_flight']"/>
                <span class="input-group-addon">R$</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 mt-10 mb-10 padding-off">
          <div class="row">
            <div class="col-md-4">
              <div class="input-group align-text-bottom">Veículo:</div>
            </div>
            <div class="col-md-8">
              <div class="input-group">
                <label class="sr-only" for="fee-vehicle">veiculo</label>
                <input type="decimal" id="fee-vehicle" name="fee-vehicle" class="form-control" placeholder="0,00" v-model="fee['fee_vehicle']"/>
                <span class="input-group-addon">R$</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 mt-10 mb-20 padding-off">
          <div class="row">
            <div class="col-md-4">
              <div class="input-group align-text-bottom">Hotel:</div>
            </div>
            <div class="col-md-8">
              <div class="input-group">
                <label class="sr-only" for="fee-hotel">hotel</label>
                <input type="text" id="fee-hotel" name="fee-hotel" class="form-control" placeholder="0,00" v-model="fee['fee_hotel']"/>
                <span class="input-group-addon">R$</span>
              </div>
            </div>
          </div>
        </div>
        </template>
        <div class="col-sm-12">
          <div class="row">
            <div class="col-4">
              <button class="btn-blue btn-block btn-small" type="submit">Atualizar Fee</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import WaitLoader from "@/components/loader/wait-loader";

export default {
  props: ["company_id"],
  data() {
    return {
      submitted: false,
      fee: { fee_flight: 0, fee_vehicle: 0, fee_hotel: 0 },
      loading: false,
      tipoCobranca: Boolean,
    };
  },
  created() {
    this.loading = true;
    this.$http
      .get("/api/company-fee?company_id=" + this.company_id)
      .then((response) => {
        if (response.status === 200) {
          this.tipoCobranca = response.data["cobranca_fee"]
          this.parsed_fee = response.data["extra"];
          this.fee = {
            fee_flight: this.parsed_fee["fee"]["flight"]["value"],
            fee_vehicle: this.parsed_fee["fee"]["vehicle"]["value"],
            fee_hotel: this.parsed_fee["fee"]["hotel"]["value"],
          };
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  components: {
    WaitLoader,
  },
  methods: {
    atualizaFee() {
      this.$http
        .post("/api/admin/company/update/fee", {
          extra: this.fee,
          company: this.company_id,
          cobranca_fee: this.tipoCobranca
        })
        .then((response) => {
          if (response.status === 200) {
            location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>